import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faHeartBroken } from "@fortawesome/free-solid-svg-icons";

class LivesCounter extends Component {
  handleLives = () => {
    console.log("props", this.props);
    if (this.props.lives === 3) {
      return (
        <div className="livescontainer">
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-3"
            icon={faHeart}
          />
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-2"
            icon={faHeart}
          />
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-1"
            icon={faHeart}
          />
        </div>
      );
    } else if (this.props.lives === 2) {
      return (
        <div className="livescontainer">
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-3"
            icon={faHeart}
          />
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-2"
            icon={faHeart}
          />
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-1 heartbreak"
            icon={faHeartBroken}
          />
        </div>
      );
    } else if (this.props.lives === 1) {
      return (
        <div className="livescontainer">
          <FontAwesomeIcon
            style={{ color: "#46ac46" }}
            className="heart-3"
            icon={faHeart}
          />
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-2 heartbreak"
            icon={faHeartBroken}
          />
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-1"
            icon={faHeartBroken}
          />
        </div>
      );
    } else {
      return (
        <div className="livescontainer">
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-3 heartbreak"
            icon={faHeartBroken}
          />
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-2"
            icon={faHeartBroken}
          />
          <FontAwesomeIcon
            style={{ color: "rgb(0, 0, 0)" }}
            className="heart-1"
            icon={faHeartBroken}
          />
        </div>
      );
    }
  };

  render() {
    {
      return this.handleLives();
    }
  }
}

export default LivesCounter;
